"use client";

import { useState } from "react";
import Link from "next/link";

function NotificationBar() {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    isVisible && (
      <div className="flex flex-wrap items-center justify-between bg-[#0D2468] px-6 py-2 text-white">
        <div className="flex w-full items-center gap-4 sm:w-auto">
          <p className="text-sm sm:text-base">
            اپلیکیشن مارول لایف هم‌اکنون در دسترس است. برای دانلود نسبت به موبایلتون روی دکمه‌
            مربوطه کلیک کنید!
          </p>
        </div>

        <div className="mt-3 flex w-full items-center justify-between gap-4 sm:mt-0 sm:w-auto sm:justify-start">
          <Link href="/">
            <p className="rounded-md bg-white px-3 py-1 text-xs text-[#0D2468] transition duration-300 ease-in-out hover:bg-gray-100 sm:text-sm">
              دانلود از گوگل پلی
            </p>
          </Link>
          <Link href="/">
            <p className="rounded-md bg-white px-3 py-1 text-xs text-[#0D2468] transition duration-300 ease-in-out hover:bg-gray-100 sm:text-sm">
              دانلود از اپ استور
            </p>
          </Link>
        </div>

        <button
          onClick={handleClose}
          className="mt-3 border-0 bg-transparent text-xl text-white hover:text-gray-200 sm:mt-0 sm:text-2xl"
        >
          ×
        </button>
      </div>
    )
  );
}

export default NotificationBar;
